export enum LoaderTypeEnum {
  Play = 'play',
  Button = 'button',
  Hand = 'hand'
}
